module.exports = __webpack_public_path__ + "assets/img/1.9e14233e.png";